import { TPaymentStatus } from "@modules/order/types";
import formatCurrency from "@utils/formatCurrency";

import { TGTMData } from "./types";

const mapOrderSuccessValuesToGTMValues = (paymentStatus: TPaymentStatus): TGTMData => ({
  deliveryMethod: paymentStatus.deliveryMethod,
  countryFrom: paymentStatus.countryFrom,
  countryTo: paymentStatus.countryTo,
  price: formatCurrency(paymentStatus.price || 0.0).replace(",", "."),
  packageSize: paymentStatus.packageSize || "",
  promoCode: paymentStatus.promoCode,
  option: "",
  identification: paymentStatus.identifier || "",
});

export default mapOrderSuccessValuesToGTMValues;
